export const getItemClickHandler = ({ column, index, onActiveItemChange, activeItemId }) => (e) => {
    const id = `${column}-${index}`;
    if (e) {
        e.stopPropagation();
    }
    onActiveItemChange(id === activeItemId ? undefined : `${column}-${index}`);
};
